var _themes;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { mix } from 'polished';
import tscStyles from '../constants/TscStyles';
import ControlButton from '../ControlButton/ControlButton';
import Avatar from '../Avatar';
import TscThemeName from '../constants/TscThemeName';
import { getClassName } from '../utils/get-class-name';
import TscAvatarSize from '../constants/TscAvatarSize';
import TscButtonType from '../constants/TscButtonType';
var ninetyPercentColorModifier = 0.9;
var eightyFivePercentColorModifier = 0.85;
var themes = (_themes = {}, _defineProperty(_themes, TscThemeName.dawn, {
  accountButton: {
    background: tscStyles.color.action.secondaryDawn,
    borderColor: tscStyles.color.text.medium,
    hoverColor: mix(ninetyPercentColorModifier, tscStyles.color.action.secondaryDawn, tscStyles.color.modifier.dark),
    activeColor: mix(eightyFivePercentColorModifier, tscStyles.color.action.secondaryDawn, tscStyles.color.modifier.dark),
    shadowColor: tscStyles.color.global.boxShadow
  },
  accountOverlay: {
    background: tscStyles.color.ui.dawn.light
  },
  overlayBody: {
    color: tscStyles.color.text.mediumDark
  }
}), _defineProperty(_themes, TscThemeName.dusk, {
  accountButton: {
    background: tscStyles.color.action.secondaryDusk,
    borderColor: tscStyles.color.ui.dusk.light,
    hoverColor: mix(ninetyPercentColorModifier, tscStyles.color.action.secondaryDusk, tscStyles.color.modifier.light),
    activeColor: mix(eightyFivePercentColorModifier, tscStyles.color.action.secondaryDusk, tscStyles.color.modifier.light),
    shadowColor: tscStyles.color.global.boxShadow
  },
  accountOverlay: {
    background: tscStyles.color.ui.dawn.light
  },
  overlayBody: {
    color: tscStyles.color.text.mediumDark
  }
}), _themes);
var focusAnimation = keyframes(["0%{box-shadow:", " 0px 0px 0px 0px}50%{box-shadow:", " 0px 0px 0px 3px}100%{box-shadow:", " 0px 0px 0px 2px}"], tscStyles.color.action.primary, tscStyles.color.action.primary, tscStyles.color.action.primary);
var AccountWidgetContainer = styled.div.withConfig({
  displayName: "AccountWidget__AccountWidgetContainer"
})(["display:flex;position:relative;"]);
var AccountButton = styled.button.attrs(function (props) {
  return props.testId ? {
    'data-test-id': props.testId
  } : {};
}).withConfig({
  displayName: "AccountWidget__AccountButton"
})(["-webkit-border-fit:border !important;-webkit-appearance:none;flex:none;display:inline-block;line-height:2.4em;white-space:nowrap;cursor:pointer;border:0;font-family:'Proxima Nova','proxima-nova',sans-serif;font-size:0.875rem;font-weight:600;letter-spacing:0.05em;text-decoration:none;text-align:center;vertical-align:middle;outline:none;position:relative;outline:none;background:transparent;border-radius:100%;box-sizing:border-box;user-select:none;width:2rem;height:2rem;padding:0;&:focus,&:hover{box-shadow:0 2px 3px ", ";}&:focus > div{animation:", " 500ms ease forwards;}&:active{box-shadow:inset 0 2px 3px ", ";}"], function (props) {
  return themes[props.themeName].accountButton.shadowColor;
}, focusAnimation, function (props) {
  return themes[props.themeName].accountButton.shadowColor;
});
var AccountOverlay = styled.div.withConfig({
  displayName: "AccountWidget__AccountOverlay"
})(["display:block;visibility:", ";position:absolute;top:100%;margin-top:1.5rem;right:-0.5rem;z-index:1;width:18rem;opacity:", ";background:", ";box-shadow:0 2px 10px 0 rgba(0,0,0,0.3);border-radius:6px;line-height:1.4;text-transform:none;transition:opacity 80ms ease-in-out,visibility 80ms linear;cursor:auto;&:before{content:'';position:absolute;top:-.5rem;z-index:-1;right:1rem;width:1rem;height:1rem;border-radius:0 0 0.1875rem;background:", ";transform:rotate(-135deg);pointer-events:none;box-shadow:2px 2px 4px 0 rgba(0,0,0,0.07);}"], function (props) {
  return props.visible ? 'visible' : 'hidden';
}, function (props) {
  return props.visible ? '1' : '0';
}, function (props) {
  return themes[props.themeName].accountOverlay.background;
}, function (props) {
  return themes[props.themeName].accountOverlay.background;
});
var OverlayBody = styled.div.withConfig({
  displayName: "AccountWidget__OverlayBody"
})(["display:flex;margin-bottom:0.75rem;padding:0.75rem 0.75rem 0 0.75rem;align-items:center;color:", ";"], function (props) {
  return themes[props.themeName].overlayBody.color;
});
var OverlayActions = styled.div.withConfig({
  displayName: "AccountWidget__OverlayActions"
})(["display:flex;padding:0 0.75rem 0.75rem 0.75rem;> *{flex:1 1 50%;margin-right:0.5rem;&:last-child{margin-right:0;}}"]);
var UserProfile = styled.div.withConfig({
  displayName: "AccountWidget__UserProfile"
})(["overflow:hidden;margin-left:0.75rem;"]);
var LoginButtonGroup = styled.span.withConfig({
  displayName: "AccountWidget__LoginButtonGroup"
})(["display:", ";"], function (props) {
  return props.isSignedIn ? 'none' : 'inline-block';
});
var UserDisplayName = styled.div.withConfig({
  displayName: "AccountWidget__UserDisplayName"
})(["font-weight:600;font-size:1.125rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);
var UserEmail = styled.div.withConfig({
  displayName: "AccountWidget__UserEmail"
})(["font-size:0.875rem;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;"]);
var defaultProps = {
  themeName: TscThemeName.dusk,
  hideSigninButton: false,
  signInButtonText: 'Sign In',
  signOutButtonText: 'Sign Out',
  myAccountButtonText: 'My Account',
  initialStateVisible: false,
  openMyAccountInNewTab: false
};
/**
 * This component is global to all TechSmith products, including desktop.
 */

var AccountWidget = function AccountWidget(props) {
  var _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
      avatarImageUrl = _defaultProps$props.avatarImageUrl,
      children = _defaultProps$props.children,
      className = _defaultProps$props.className,
      hideSigninButton = _defaultProps$props.hideSigninButton,
      initialStateVisible = _defaultProps$props.initialStateVisible,
      isSignedIn = _defaultProps$props.isSignedIn,
      myAccountButtonText = _defaultProps$props.myAccountButtonText,
      myAccountUrl = _defaultProps$props.myAccountUrl,
      onDismiss = _defaultProps$props.onDismiss,
      onMyAccountClick = _defaultProps$props.onMyAccountClick,
      onSignInClick = _defaultProps$props.onSignInClick,
      onSignOutClick = _defaultProps$props.onSignOutClick,
      signInButtonText = _defaultProps$props.signInButtonText,
      signInUrl = _defaultProps$props.signInUrl,
      signOutButtonText = _defaultProps$props.signOutButtonText,
      signOutUrl = _defaultProps$props.signOutUrl,
      testId = _defaultProps$props.testId,
      themeName = _defaultProps$props.themeName,
      userDisplayName = _defaultProps$props.userDisplayName,
      userEmail = _defaultProps$props.userEmail,
      userID = _defaultProps$props.userID,
      openMyAccountInNewTab = _defaultProps$props.openMyAccountInNewTab; // overlay the defaultProps and passed in props in logical order and spread to constant values


  var _React$useState = React.useState({
    visible: initialStateVisible
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      state = _React$useState2[0],
      setState = _React$useState2[1];

  var accountWidgetRef = React.useRef(null);

  var hideOverlayThenCallClickEvent = function hideOverlayThenCallClickEvent(eventHandler) {
    if (!eventHandler) {
      return function () {};
    }

    return function (e) {
      setState({
        visible: false
      });
      eventHandler(e);
    };
  };

  var handleClickOutside = React.useCallback(function (event) {
    if (!accountWidgetRef.current || !accountWidgetRef.current.contains(event === null || event === void 0 ? void 0 : event.target)) {
      if (state.visible) {
        setState({
          visible: false
        });

        if (onDismiss) {
          onDismiss(event);
        }
      }
    }
  }, [state.visible, onDismiss]);
  React.useEffect(function () {
    document.addEventListener('click', handleClickOutside, true);
    return function () {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [handleClickOutside]);

  var _toggleWidget = function _toggleWidget(e) {
    e.stopPropagation();
    var newVisible = !state.visible;
    setState({
      visible: newVisible
    });

    if (!newVisible && onDismiss) {
      onDismiss(e);
    }
  };

  return _jsxs(AccountWidgetContainer, {
    className: getClassName(className, null, 'account-widget-container'),
    ref: accountWidgetRef,
    children: [!hideSigninButton && _jsx(LoginButtonGroup, {
      className: getClassName(className, 'login-button-group'),
      isSignedIn: isSignedIn,
      children: _jsx(ControlButton, {
        className: getClassName(className, 'signin'),
        themeName: themeName,
        buttonType: TscButtonType.secondary,
        href: signInUrl,
        onClick: onSignInClick,
        label: signInButtonText,
        testId: "".concat(testId || 'account-widget', "-signin-button")
      })
    }), isSignedIn && _jsx(AccountButton, {
      className: getClassName(className, 'account-button'),
      title: "View user profile",
      onClick: _toggleWidget,
      testId: "".concat(testId || 'account-widget', "-profile-button"),
      "aria-expanded": state.visible,
      themeName: themeName,
      children: _jsx(Avatar, {
        className: getClassName(className, 'medium'),
        avatarImageUrl: avatarImageUrl,
        userDisplayName: userDisplayName,
        userID: userID,
        size: TscAvatarSize.medium
      })
    }), _jsxs(AccountOverlay, {
      className: getClassName(className, 'account-overlay'),
      visible: state.visible,
      themeName: themeName,
      children: [_jsxs(OverlayBody, {
        className: getClassName(className, 'overlay-body'),
        visible: state.visible,
        themeName: themeName,
        children: [_jsx(Avatar, {
          className: getClassName(className, 'large'),
          avatarImageUrl: avatarImageUrl,
          userDisplayName: userDisplayName,
          userID: userID,
          size: TscAvatarSize.large
        }), _jsxs(UserProfile, {
          className: getClassName(className, 'user-profile'),
          children: [_jsx(UserDisplayName, {
            className: getClassName(className, 'user-display-name'),
            title: userDisplayName,
            children: userDisplayName
          }), _jsx(UserEmail, {
            className: getClassName(className, 'user-email'),
            title: userEmail,
            children: userEmail
          })]
        })]
      }), children, _jsxs(OverlayActions, {
        className: getClassName(className, 'overlay-actions'),
        children: [(myAccountUrl || onMyAccountClick) && _jsx(ControlButton, {
          className: getClassName(className, 'myaccount'),
          themeName: TscThemeName.dawn,
          buttonType: TscButtonType.secondary,
          href: myAccountUrl,
          onClick: onMyAccountClick ? function (e) {
            return hideOverlayThenCallClickEvent(onMyAccountClick)(e);
          } : undefined,
          label: myAccountButtonText,
          testId: "".concat(testId || 'account-widget', "-myaccount-button"),
          openLinkInNewTab: openMyAccountInNewTab
        }), _jsx(ControlButton, {
          className: getClassName(className, 'signout'),
          themeName: TscThemeName.dawn,
          buttonType: TscButtonType.secondary,
          href: signOutUrl,
          onClick: onSignOutClick ? function (e) {
            return hideOverlayThenCallClickEvent(onSignOutClick)(e);
          } : undefined,
          label: signOutButtonText,
          testId: "".concat(testId || 'account-widget', "-signout-button")
        })]
      })]
    })]
  });
};

AccountWidget.defaultProps = defaultProps;
var AccountWidgetTest = {
  AccountButton: AccountButton,
  Container: AccountWidgetContainer,
  LoginButtonGroup: LoginButtonGroup
};
export { AccountWidget, AccountWidgetTest };
export default AccountWidget;